export default __webpack_public_path__ + "locales/hy-AM/Article.json?hash=a5dda1db061d4a4a0503b9ab3e6cde7b";